import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import LocationDTO from '@/models/location'
import { integerRange, latitudeRange, longitudeRange } from '@/utils/constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationCoordinates',
  props: {
    location: null,
    hideGeofence: { type: Boolean, default: false }
  },
  emits: ['updated'],
  setup(__props: any, { emit }) {

const props = __props as { location: LocationDTO, hideGeofence: boolean }


const geofenceFlag = ref(false)
const latitudeRules = [
  (v: string) =>
    (parseFloat(v) < latitudeRange.min || parseFloat(v) > latitudeRange.max) &&
    'Latitude must be between -90 and 90',
]
const longitudeRules = [
  (v: string) =>
    (parseFloat(v) < longitudeRange.min ||
      parseFloat(v) > longitudeRange.max) &&
    'Longitude must be between -180 and 180',
]
const radiusRules = [
  (v: string) => parseFloat(v) < 75 && `Radius must be 75 meters or greater`,
  (v: string) =>
    parseFloat(v) >= 75 &&
    parseFloat(v) <= integerRange.max &&
    !Number.isInteger(parseFloat(v)) &&
    `Please enter a whole number`,
  (v: string) =>
    parseFloat(v) > integerRange.max && `Please enter a smaller radius`,
]

const geofenceHint = computed(() => {
  if (props.location.radius && props.location.radius < 200) {
    return 'Going below 200 meters may cause geofence inaccuracies'
  }
  return ''
})
const showGeofenceField = computed(
  () => geofenceFlag.value || props.location.radius !== null
)
const disabled = computed(() => !props.location.canEdit)


function onLocationUpdated(data: { field: string; value: any }) {
  emit('updated', data)
}

return { __sfc: true,props, geofenceFlag, latitudeRules, longitudeRules, radiusRules, geofenceHint, showGeofenceField, disabled, emit, onLocationUpdated }
}

})